// extracted by mini-css-extract-plugin
var _1 = "FilterToggle-modulefilter__dknE3";
var _2 = "FilterToggle-moduleswitch__uv7N6";
export { _1 as "filter", _2 as "switch" }
